<template>
  <div class="container-fluid">
    <route-header>
      <h3>{{ $t('labels.nav.transactions') }}</h3>
      <p class="bg-indigo text-white d-inline px-2" v-if="selectedTotal">
        {{ $n(selectedTotal, 'currency') }}
      </p>
    </route-header>
    <div class="row">
      <div class="col">
        <transactions @displayTotal="displayTotal" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Transaction',
  data () {
    return {
      selectedTotal: 0
    }
  },
  methods: {
    displayTotal (payload) {
      this.selectedTotal = payload
    }
  }
}
</script>
